// ── PARALLAX BACKGROUNDS ──
var parallaxEls = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
if (parallaxEls.length) {
  var PARALLAX_MAX = 60;
  var parallaxTicking = false;
  function updateParallax() {
    var vh = window.innerHeight;
    parallaxEls.forEach(function(el) {
      var speed = parseFloat(el.getAttribute('data-parallax')) || 0.2;
      var rect = el.parentElement.getBoundingClientRect();
      var centerOffset = rect.top + rect.height / 2 - vh / 2;
      var py = Math.max(-PARALLAX_MAX, Math.min(PARALLAX_MAX, -centerOffset * speed));
      el.style.setProperty('--py', py.toFixed(1) + 'px');
    });
    parallaxTicking = false;
  }
  window.addEventListener('scroll', function() {
    if (!parallaxTicking) {
      requestAnimationFrame(updateParallax);
      parallaxTicking = true;
    }
  }, { passive: true });
  updateParallax();
}

// ── SCROLL REVEAL ──
// Split text of [data-reveal="letters"] elements into per-letter spans (skips
// existing element nodes like <br>) so CSS can flicker/ignite them individually.
function splitIntoLetters(root) {
  var i = 0;
  function isBreak(node) {
    return node && node.nodeType === Node.ELEMENT_NODE && node.tagName === 'BR';
  }
  function process(nodes) {
    nodes.forEach(function(node, idx) {
      if (node.nodeType === Node.TEXT_NODE) {
        var text = node.textContent.replace(/\s+/g, ' ');
        if (idx === 0 || isBreak(nodes[idx - 1])) text = text.replace(/^ /, '');
        if (idx === nodes.length - 1 || isBreak(nodes[idx + 1])) text = text.replace(/ $/, '');
        var frag = document.createDocumentFragment();
        for (var c = 0; c < text.length; c++) {
          var ch = text[c];
          var span = document.createElement('span');
          span.className = 'ltr';
          span.style.setProperty('--i', i++);
          span.textContent = ch === ' ' ? ' ' : ch;
          frag.appendChild(span);
        }
        node.parentNode.replaceChild(frag, node);
      } else if (node.nodeType === Node.ELEMENT_NODE) {
        process(Array.prototype.slice.call(node.childNodes));
      }
    });
  }
  process(Array.prototype.slice.call(root.childNodes));
}
document.querySelectorAll('[data-reveal="letters"]').forEach(splitIntoLetters);

var observer = new IntersectionObserver(function(entries) {
  entries.forEach(function(e) { if (e.isIntersecting) e.target.classList.add('visible'); });
}, {threshold: 0.12, rootMargin: '0px 0px -40px 0px'});
document.querySelectorAll('[data-reveal]').forEach(function(el) { observer.observe(el); });

// ── SCROLL HINT ──
var scrollHint = document.getElementById('scrollHint');
if (scrollHint) {
  scrollHint.addEventListener('click', function() {
    var next = document.getElementById('wabi');
    if (next) next.scrollIntoView({behavior: 'smooth'});
  });
  scrollHint.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      scrollHint.click();
    }
  });
}

// ── FAQ ACCORDION ──
document.querySelectorAll('.faq-item').forEach(function(item) {
  var question = item.querySelector('.faq-question');
  question.addEventListener('click', function() {
    var isOpen = item.classList.contains('open');
    document.querySelectorAll('.faq-item.open').forEach(function(openItem) {
      openItem.classList.remove('open');
      openItem.querySelector('.faq-question').setAttribute('aria-expanded', 'false');
    });
    if (!isOpen) {
      item.classList.add('open');
      question.setAttribute('aria-expanded', 'true');
    }
  });
});

// ── SIDE NAV ──
var sections = ['hero','wabi','gift','faq','stores'];
var navItems = document.querySelectorAll('.side-nav-item');

function updateActiveNav() {
  var scrollY = window.scrollY + window.innerHeight * 0.35;
  var current = 'hero';
  sections.forEach(function(id) {
    var el = document.getElementById(id);
    if (el && el.offsetTop <= scrollY) current = id;
  });
  navItems.forEach(function(item) {
    item.classList.toggle('active', item.dataset.target === current);
  });
}

window.addEventListener('scroll', updateActiveNav, {passive: true});

navItems.forEach(function(item) {
  item.addEventListener('click', function() {
    var target = document.getElementById(item.dataset.target);
    if (target) {
      target.scrollIntoView({behavior:'smooth'});
      var dot = item.querySelector('.sn-dot');
      var rect = dot.getBoundingClientRect();
      spawnFirework(rect.left + rect.width / 2, rect.top + rect.height / 2);
    }
  });
  item.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      item.click();
    }
  });
});

// ── FIREWORK ──
var fwCanvas = document.getElementById('fwCanvas');
var fwCtx = fwCanvas.getContext('2d');
var particles = [];

fwCanvas.width = window.innerWidth;
fwCanvas.height = window.innerHeight;
window.addEventListener('resize', function() {
  fwCanvas.width = window.innerWidth;
  fwCanvas.height = window.innerHeight;
});

var COLORS = [
  'rgba(236,106,44,',
  'rgba(255,160,80,',
  'rgba(255,210,140,',
  'rgba(255,255,220,',
  'rgba(220,80,30,',
];

function spawnFirework(x, y) {
  var count = 38;
  for (var i = 0; i < count; i++) {
    var angle = (Math.PI * 2 / count) * i + (Math.random() - .5) * .3;
    var speed = 1.2 + Math.random() * 3.2;
    var size  = .8 + Math.random() * 2.2;
    var life  = 0.55 + Math.random() * 0.45;
    var color = COLORS[Math.floor(Math.random() * COLORS.length)];
    particles.push({
      x: x, y: y,
      vx: Math.cos(angle) * speed,
      vy: Math.sin(angle) * speed,
      alpha: 1,
      decay: 1 / (life * 60),
      size: size,
      color: color,
      spark: Math.random() > .65,
    });
  }
  for (var j = 0; j < 8; j++) {
    var a2 = Math.random() * Math.PI * 2;
    particles.push({
      x: x, y: y,
      vx: Math.cos(a2) * (0.3 + Math.random() * .8),
      vy: Math.sin(a2) * (0.3 + Math.random() * .8) - 0.6,
      alpha: 0.9,
      decay: 0.008 + Math.random() * 0.006,
      size: 1.5 + Math.random() * 1.5,
      color: COLORS[0],
      spark: false,
      gravity: 0.018,
    });
  }
  if (!fwAnimating) requestAnimationFrame(fwLoop);
  fwAnimating = true;
}

var fwAnimating = false;

function fwLoop() {
  fwCtx.clearRect(0, 0, fwCanvas.width, fwCanvas.height);

  for (var i = particles.length - 1; i >= 0; i--) {
    var p = particles[i];
    p.x += p.vx;
    p.y += p.vy;
    p.vx *= 0.93;
    p.vy *= 0.93;
    if (p.gravity) p.vy += p.gravity;
    p.alpha -= p.decay;

    if (p.alpha <= 0) { particles.splice(i, 1); continue; }

    fwCtx.save();
    fwCtx.globalAlpha = Math.max(0, p.alpha);
    if (p.spark) {
      fwCtx.strokeStyle = p.color + p.alpha + ')';
      fwCtx.lineWidth = p.size * .5;
      fwCtx.lineCap = 'round';
      var s = p.size * 2.5;
      fwCtx.beginPath();
      fwCtx.moveTo(p.x - s, p.y); fwCtx.lineTo(p.x + s, p.y);
      fwCtx.moveTo(p.x, p.y - s); fwCtx.lineTo(p.x, p.y + s);
      fwCtx.stroke();
    } else {
      fwCtx.fillStyle = p.color + p.alpha + ')';
      fwCtx.shadowColor = p.color + '0.6)';
      fwCtx.shadowBlur = p.size * 4;
      fwCtx.beginPath();
      fwCtx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
      fwCtx.fill();
    }
    fwCtx.restore();
  }

  if (particles.length > 0) {
    requestAnimationFrame(fwLoop);
  } else {
    fwAnimating = false;
    fwCtx.clearRect(0, 0, fwCanvas.width, fwCanvas.height);
  }
}

// ── LANTERN GLOW (gift section) ──
var giftSection  = document.getElementById('gift');
var lanternWrap  = document.getElementById('lanternWrap');
var lanternModel = document.getElementById('lanternModel');
var isLit = false;
var exposureToken = 0;
var flickerTimeout = null;
var IGNITE_DURATION = 3200;

function easeInOutCubic(t) {
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

function animateExposure(el, from, to, duration) {
  var myToken = ++exposureToken;
  var start = null;
  function step(ts) {
    if (myToken !== exposureToken) return;
    if (start === null) start = ts;
    var t = Math.min(1, (ts - start) / duration);
    var eased = easeInOutCubic(t);
    el.exposure = from + (to - from) * eased;
    if (t < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

function setLit(lit) {
  isLit = lit;
  giftSection.classList.toggle('lit', lit);
  lanternWrap.classList.toggle('lit', lit);
  clearTimeout(flickerTimeout);
  if (lit) {
    flickerTimeout = setTimeout(function() {
      lanternWrap.classList.add('forever-lit');
    }, IGNITE_DURATION);
  } else {
    lanternWrap.classList.remove('forever-lit');
  }
  if (lanternModel) {
    var current = (typeof lanternModel.exposure === 'number') ? lanternModel.exposure : (lit ? 0.85 : 1.05);
    animateExposure(lanternModel, current, lit ? 1.05 : 0.85, IGNITE_DURATION);
  }
}

// click alone is unreliable through <model-viewer camera-controls> on touch
// devices (the orbit gesture can swallow the synthesized click), so tap
// vs. drag is detected explicitly from raw pointer movement/timing instead.
var TAP_MOVE_PX = 10;
var TAP_MAX_MS = 500;
var tapStart = null;

var lanternHint = document.getElementById('lanternHint');
var lanternTapHint = document.getElementById('lanternTapHint');

lanternWrap.addEventListener('pointerdown', function(e) {
  tapStart = {x: e.clientX, y: e.clientY, t: Date.now()};
  if (lanternHint) lanternHint.classList.add('hidden');
  if (lanternTapHint) lanternTapHint.classList.add('hidden');
});

lanternWrap.addEventListener('pointerup', function(e) {
  if (!tapStart) return;
  var dx = e.clientX - tapStart.x;
  var dy = e.clientY - tapStart.y;
  var moved = Math.sqrt(dx * dx + dy * dy) > TAP_MOVE_PX;
  var elapsed = Date.now() - tapStart.t;
  tapStart = null;
  if (!moved && elapsed < TAP_MAX_MS) {
    setLit(!isLit);
  }
});

var inGift = false;
var lanternRevealed = false;

var igniteTimeout = null;

var giftObserver = new IntersectionObserver(function(entries) {
  entries.forEach(function(e) {
    if (e.isIntersecting && !inGift) {
      clearTimeout(igniteTimeout);
      igniteTimeout = setTimeout(function() { setLit(true); }, 500);
    } else if (!e.isIntersecting && inGift) {
      clearTimeout(igniteTimeout);
      setLit(false);
    }
    inGift = e.isIntersecting;
  });
}, {threshold: 0.18});
giftObserver.observe(giftSection);

// ── TORCH ──
var torchOverlay = document.getElementById('torchOverlay');

// Ambient only — no cursor tracking
window.addEventListener('scroll', function() {
  var giftBottom = giftSection.offsetTop + giftSection.offsetHeight;
  var atOutro    = window.scrollY > giftBottom - window.innerHeight * 0.4;

  if (inGift && !lanternRevealed) {
    var gr = giftSection.getBoundingClientRect();
    if (gr.top <= 0) {
      lanternRevealed = true;
      lanternWrap.classList.add('revealed');
    }
  }

  torchOverlay.style.opacity = atOutro ? '0' : (inGift ? '0' : '1');
}, {passive: true});

updateActiveNav();
